import { EnrollmentReviewBenefitItemsDto } from '@zorro/clients';
import { Divider } from '@zorro/design-system/v2/Divider';
import { Grid, Group, Text } from '@zorro/web/design-system';
import { ReactNode } from 'react';

import { EnrollmentReviewCardCurrency } from './EnrollmentReviewCardCurrency';

type Props = {
  stipend: number | undefined;
  totals: Pick<
    EnrollmentReviewBenefitItemsDto,
    | 'totalPremium'
    | 'totalEmployeeContribution'
    | 'totalEmployerContribution'
    | 'balance'
  >;
  // Info icon + tooltip next to "Total allowance"; omitted where nothing extra is shown.
  allowanceTooltip?: ReactNode;
  // The per-benefit plan rows block; omitted where the flow shows totals only.
  planDetails?: ReactNode;
};

export const EnrollmentReviewCardContent = ({
  stipend,
  totals,
  allowanceTooltip,
  planDetails,
}: Props) => (
  <Grid
    bg="var(--color-background-general-note-primary)"
    gap={0}
    bdrs="sm"
    p="lg"
  >
    <Grid.Col span={8}>
      <Group gap="0.25rem">
        <Text fw={600}>Total allowance</Text>
        {allowanceTooltip}
      </Group>
    </Grid.Col>
    <Grid.Col span={4}>
      <EnrollmentReviewCardCurrency fw={600}>
        {stipend}
      </EnrollmentReviewCardCurrency>
    </Grid.Col>
    {planDetails}
    <Grid.Col span={8} my="sm">
      <Text fw={600}>Total premium</Text>
    </Grid.Col>
    <Grid.Col span={4} my="sm">
      <EnrollmentReviewCardCurrency fw={600}>
        {totals.totalPremium}
      </EnrollmentReviewCardCurrency>
    </Grid.Col>
    <Grid.Col span={8} mb="sm">
      <Text size="sm" c="var(--color-text-default-secondary)">
        Balance
      </Text>
    </Grid.Col>
    <Grid.Col span={4} mb="sm">
      <EnrollmentReviewCardCurrency style={{ textWrap: 'nowrap' }}>
        {totals.balance}
      </EnrollmentReviewCardCurrency>
    </Grid.Col>
    <Grid.Col>
      <Divider />
    </Grid.Col>
    <Grid.Col span={8} mt="sm">
      <Text size="sm" c="var(--color-text-default-secondary)">
        Employee contribution
      </Text>
    </Grid.Col>
    <Grid.Col span={4} mt="sm">
      <EnrollmentReviewCardCurrency>
        {totals.totalEmployeeContribution}
      </EnrollmentReviewCardCurrency>
    </Grid.Col>
    <Grid.Col span={8} mt="0.25rem">
      <Text size="sm" c="var(--color-text-default-secondary)">
        Employer contribution
      </Text>
    </Grid.Col>
    <Grid.Col span={4} mt="0.25rem">
      <EnrollmentReviewCardCurrency>
        {totals.totalEmployerContribution}
      </EnrollmentReviewCardCurrency>
    </Grid.Col>
  </Grid>
);
